import ListadoVacantesAprobadasScreen from "../components/ListadoVacantesAprobadasScreen ";
import { EditarContratacionScreen } from "../components/EditarContratacionScreen";
import ListadoSolicitudesReingreso from "../components/ListadoSolicitudReingreso";
import HistorialDeReingresos from "../components/historialDeReingresos";
import FormContratacionScreen from "../components/FormContratacionScreen";
import ListadoVacantesScreen from "../components/ListadoVacantesScreen";
import DetalleVacanteScreen from "../components/DetalleVacanteScreen";
import ConsultarRutScreen from "../components/ConsultarRutScreen";
import { Routes, Route, useLocation } from "react-router-dom";
import VerVacateScreen from "../components/VerVacateScreen";
import { DataContext } from "../contextData/contextData";
import { useContext } from "react";
import PropTypes from 'prop-types';

// // Componentes viejos
import { ResumenSolicitudes } from "../components/ResumenSolicitudes"; // descomantar para usar el componente viejo
import { PorEnviarSAP } from "../components/PorEnviarSAP"; // descomantar para usar el componete viejo

import MonitorConfirmalo from '../pages/firmaContrato/monitor/MonitorConfirmalo';
import { AccesoDenegado } from '../pages/errores/accesoDenegado/accesoDenegado';
import { NoAutorizado } from '../pages/errores/noAutorizado/noAutorizado';
import MonitorFirma from '../pages/firmaContrato/monitor/MonitorWebdox';
import { PageNotFound } from "../pages/errores/PageNotFound/404page";
import Contrato from '../pages/firmaContrato/contratos/Contrato';
import LogTemporis from "../pages/temporis/LogTemporis";
import { returNombreRuta } from "../utils/funciones";
import Monitor from '../pages/monitor/Index';

const Acceso = ({ el, acc = [] }) => acc.includes(localStorage.getItem('id_perfil')) ? el : <NoAutorizado />;
const AccesoFirma = ({ el, acc = [] }) => acc.includes(localStorage.getItem('puedeverfirma')) ? el : <NoAutorizado />;

Acceso.propTypes = {
  el: PropTypes.node.isRequired,
  acc: PropTypes.arrayOf(PropTypes.string),
};

AccesoFirma.propTypes = {
  el: PropTypes.node.isRequired,
  acc: PropTypes.arrayOf(PropTypes.string),
};

const ReturnIndex = () => {
  return {
    '6': <Monitor />,
    '7': <Contrato />,
  }[localStorage.getItem('id_perfil')] || <ListadoVacantesScreen />;
}

const puedeVer = () => {
  const puede = localStorage.getItem('puedeverfirma');
  return puede;
}

const AppRoute = () => {
  const { setNombreMenu } = useContext(DataContext);
  const location = useLocation();
  setNombreMenu(returNombreRuta(location.pathname));

  return (
    <div className="containerfluid px-4 p-0">
      <Routes>
        <Route path="/" element={<ReturnIndex />} />
        <Route path="/listSolicitudAprobadas" element={<ListadoVacantesAprobadasScreen />} />
        <Route path="/listSolicitudReingreso" element={<ListadoSolicitudesReingreso />} />
        <Route path="/historial-reingresos" element={<Acceso el={<HistorialDeReingresos />} acc={['4', '2']} />} />
        <Route path="/consulta-rut" element={<Acceso el={<ConsultarRutScreen />} acc={['4']} />} />
        <Route path="/formulario-contratacion/:idPersona" element={<Acceso el={<FormContratacionScreen />} acc={['4']} />} />
        <Route path="/formulario-contratacion" element={<Acceso el={<FormContratacionScreen />} acc={['4']} />} />
        <Route path="/detalle-vacante/:idSolicitud" element={<DetalleVacanteScreen />} />
        <Route path="/firma-contrato" element={<AccesoFirma el={<Contrato />} acc={['1']} />} />
        <Route path="/monitor-firma" element={<AccesoFirma el={<MonitorFirma />} acc={['1']} />} />
        <Route path="/monitor-confirmalo" element={<AccesoFirma el={<MonitorConfirmalo />} acc={['1']} />} />
        <Route path="/envio-sap" element={<Acceso el={<PorEnviarSAP />} acc={['3']} />} />
        <Route path="/vacante/:idSolicitud" element={<VerVacateScreen />} />
        <Route path="/editar-vacante/:idSolicitud" element={<EditarContratacionScreen />} />
        <Route path="/log-temporis" element={<LogTemporis />} />
        {/* <Route path="detalle-temporis/:id" element={<DetalleLogScreen />} /> */} {/* esta ruta no se usa en ninguna parte */}
        <Route path="/resumen-solicitudes" element={<ResumenSolicitudes />} />
        <Route path="/monitor" element={<Acceso el={<Monitor />} acc={['6']} />} />
        <Route path='/acceso-denegado' element={<AccesoDenegado />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
};

export default AppRoute;
